module.exports = __webpack_public_path__ + "static/media/virtual-dom.e6a30a25.png";